<template>
  <div class="u-svg-text">
    <svg
      width="455px"
      height="40px"
      viewBox="0 0 455 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>{{ innerText }}</title>
      <defs>
        <linearGradient
          id="linearGradient-1"
          x1="50%"
          y1="66.8633323%"
          x2="50%"
          y2="100%"
        >
          <stop
            stop-color="#FFFFFF"
            offset="0%"
          />
          <stop
            stop-color="#61B0FF"
            offset="100%"
          />
        </linearGradient>
        <linearGradient
          id="linearGradient-2"
          x1="50%"
          y1="66.8633323%"
          x2="50%"
          y2="100%"
        >
          <stop
            stop-color="#FFFFFF"
            offset="0%"
          />
          <stop
            stop-color="#61B0FF"
            offset="100%"
          />
        </linearGradient>
        <linearGradient
          id="linearGradient-3"
          x1="50%"
          y1="66.8633323%"
          x2="50%"
          y2="100%"
        >
          <stop
            stop-color="#FFFFFF"
            offset="0%"
          />
          <stop
            stop-color="#61B0FF"
            offset="100%"
          />
        </linearGradient>
        <linearGradient
          id="linearGradient-4"
          x1="50%"
          y1="66.8633323%"
          x2="50%"
          y2="100%"
        >
          <stop
            stop-color="#FFFFFF"
            offset="0%"
          />
          <stop
            stop-color="#61B0FF"
            offset="100%"
          />
        </linearGradient>
        <linearGradient
          id="linearGradient-5"
          x1="50%"
          y1="66.8633323%"
          x2="50%"
          y2="100%"
        >
          <stop
            stop-color="#FFFFFF"
            offset="0%"
          />
          <stop
            stop-color="#61B0FF"
            offset="100%"
          />
        </linearGradient>
        <linearGradient
          id="linearGradient-6"
          x1="50%"
          y1="66.8633323%"
          x2="50%"
          y2="100%"
        >
          <stop
            stop-color="#FFFFFF"
            offset="0%"
          />
          <stop
            stop-color="#61B0FF"
            offset="100%"
          />
        </linearGradient>
        <linearGradient
          id="linearGradient-7"
          x1="50%"
          y1="66.8633323%"
          x2="50%"
          y2="100%"
        >
          <stop
            stop-color="#FFFFFF"
            offset="0%"
          />
          <stop
            stop-color="#61B0FF"
            offset="100%"
          />
        </linearGradient>
        <linearGradient
          id="linearGradient-8"
          x1="50%"
          y1="66.8633323%"
          x2="50%"
          y2="100%"
        >
          <stop
            stop-color="#FFFFFF"
            offset="0%"
          />
          <stop
            stop-color="#61B0FF"
            offset="100%"
          />
        </linearGradient>
        <linearGradient
          id="linearGradient-9"
          x1="50%"
          y1="66.8633323%"
          x2="50%"
          y2="100%"
        >
          <stop
            stop-color="#FFFFFF"
            offset="0%"
          />
          <stop
            stop-color="#61B0FF"
            offset="100%"
          />
        </linearGradient>
      </defs>
      <g
        id="页面-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="机器人平台UI"
          transform="translate(-721.000000, -12.000000)"
          fill-rule="nonzero"
        >
          <g
            :id="innerText"
            transform="translate(721.946327, 12.971664)"
          >
            <path
              id="形状"
              d="M27.28,33.96 L33.08,33.96 L33.08,25.12 L24.4,25.12 C24,25.12 23.6,25.0533333 23.2,24.92 C22.8,24.7866667 22.44,24.5933333 22.12,24.34 C21.8,24.0866667 21.54,23.78 21.34,23.42 C21.14,23.06 21.04,22.6533333 21.04,22.2 L21.04,4.8 C21.04,4.37333333 21.1266667,4 21.3,3.68 C21.4733333,3.36 21.7,3.09333333 21.98,2.88 C22.26,2.66666667 22.5733333,2.50666667 22.92,2.4 C23.2666667,2.29333333 23.6133333,2.24 23.96,2.24 L25.68,2.24 L26.24,0 L32,0 L31.52,2.24 L37.96,2.24 L37.96,16.84 C37.96,17.6666667 37.6466667,18.2933333 37.02,18.72 C36.3933333,19.1466667 35.72,19.36 35,19.36 L28.2,19.36 L27.72,14.76 L32.4,14.76 L32.4,6.92 L26.6,6.92 L26.6,20.44 L38.64,20.44 L38.64,36.04 C38.64,36.8666667 38.3333333,37.5 37.72,37.94 C37.1066667,38.38 36.44,38.6 35.72,38.6 L27.72,38.6 L27.28,33.96 Z M8.84,31.48 L11.36,31.48 L11.36,7.36 L8.96,7.36 L8.96,2.4 L19.96,2.4 L19.96,7.36 L17.52,7.36 L17.52,31.48 L20.04,31.48 L20.04,36.44 L8.84,36.44 L8.84,31.48 Z M-2.27373675e-13,38.52 L2.28,23.56 L8.56,23.56 L6.16,38.52 L-2.27373675e-13,38.52 Z M20.64,27.04 L32,27.04 L32,32 L20.64,32 L20.64,27.04 Z M6.28,11.84 L8.6,20.76 L2.36,20.76 L0.12,11.84 L6.28,11.84 Z M6.48,0.4 L8.64,9.32 L2.48,9.32 L0.32,0.4 L6.48,0.4 Z M31,8.04 L31.64,13.48 L28.04,13.48 L27.4,8.04 L31,8.04 Z"
              fill="url(#linearGradient-1)"
            />
            <path
              id="形状"
              d="M52.68,34.72 L70.52,29.76 L70.52,28.56 L54.32,32.96 L52.6,29.6 L69.8,24.92 L69.04,24.08 L55.2,27.76 L53.48,24.28 L61,22.28 L52.64,22.28 L52.64,17.96 L90,17.96 L90,22.28 L74.52,22.28 L76.12,24.08 C76.52,24.48 76.72,24.92 76.72,25.4 L76.72,36.6 C76.72,37.2933333 76.4666667,37.7933333 75.96,38.1 C75.4533333,38.4066667 74.8933333,38.56 74.28,38.56 L65.84,38.56 L65.36,35.08 L54.44,38.12 L52.68,34.72 Z M77.12,7.36 L77.12,6.04 L65.52,6.04 L65.52,7.36 L59.32,7.36 L59.32,6.04 L52.4,6.04 L52.4,1.4 L59.32,1.4 L59.32,0.08 L65.52,0.08 L65.52,1.4 L77.12,1.4 L77.12,0.08 L83.32,0.08 L83.32,1.4 L90.24,1.4 L90.24,6.04 L83.32,6.04 L83.32,7.36 L77.12,7.36 Z M52.64,14.84 L52.64,10.28 C52.64,9.88 52.7533333,9.53333333 52.98,9.24 C53.2066667,8.94666667 53.4933333,8.70666667 53.84,8.52 C54.1866667,8.33333333 54.56,8.2 54.96,8.12 C55.36,8.04 55.72,8 56.04,8 L89.96,8 L89.96,14.84 L83.76,14.84 L83.76,12.32 L58.88,12.32 L58.88,14.84 L52.64,14.84 Z M83.2,38 L78.84,29.4 C78.76,29.2666667 78.7466667,29.12 78.8,28.96 C78.8533333,28.8 78.92,28.6666667 79,28.56 L82.48,23.12 L89.04,23.12 L85.56,28.56 C85.48,28.6666667 85.4133333,28.8 85.36,28.96 C85.3066667,29.12 85.32,29.2666667 85.4,29.4 L89.76,38 L83.2,38 Z M59.6,13.24 L83.04,13.24 L83.04,16.96 L59.6,16.96 L59.6,13.24 Z M70.52,34.68 L70.52,33.68 L66.88,34.68 L70.52,34.68 Z"
              fill="url(#linearGradient-2)"
            />
            <path
              id="形状"
              d="M141.28,21.96 L141.28,35.88 C141.28,36.3333333 141.166667,36.7133333 140.94,37.02 C140.713333,37.3266667 140.426667,37.5866667 140.08,37.8 C139.733333,38.0133333 139.353333,38.1666667 138.94,38.26 C138.526667,38.3533333 138.146667,38.4 137.8,38.4 L106.56,38.4 L106.56,24.48 C106.56,24.0533333 106.673333,23.68 106.9,23.36 C107.126667,23.04 107.406667,22.7733333 107.74,22.56 C108.073333,22.3466667 108.44,22.1933333 108.84,22.1 C109.24,22.0066667 109.626667,21.96 110,21.96 L141.28,21.96 Z M142.12,1 L142.12,17.84 C142.12,18.2933333 142.013333,18.6933333 141.8,19.04 C141.586667,19.3866667 141.306667,19.68 140.96,19.92 C140.613333,20.16 140.24,20.3466667 139.84,20.48 C139.44,20.6133333 139.04,20.68 138.64,20.68 L125.68,20.68 L125.68,3.84 C125.68,3.38666667 125.786667,2.98666667 126,2.64 C126.213333,2.29333333 126.486667,2 126.82,1.76 C127.153333,1.52 127.52,1.33333333 127.92,1.2 C128.32,1.06666667 128.72,1 129.12,1 L142.12,1 Z M125.04,20.64 L118.08,20.64 L115.2,16.16 L112.28,19.76 C111.986667,20.1066667 111.646667,20.36 111.26,20.52 C110.873333,20.68 110.453333,20.76 110,20.76 L104.96,20.76 L104.56,16.04 L108.08,16.04 L109.84,13.88 L104.56,13.88 L104.56,9.56 L112.24,9.56 L112.24,6.12 L110.32,6.12 L109.88,8.6 L104.52,8.6 L105.96,0.12 L111.36,0.12 L111.04,1.8 L124.08,1.8 L124.08,6.12 L118.44,6.12 L118.44,9.56 L124.72,9.56 L124.72,13.88 L117,13.88 L116.12,14.96 L121.36,14.96 L125.04,20.64 Z M131.84,5.92 L131.84,15.76 L135.92,15.76 L135.92,5.92 L131.84,5.92 Z M135.08,26.64 L112.72,26.64 L112.72,28.2 L135.08,28.2 L135.08,26.64 Z M135.08,33.72 L135.08,32.2 L112.72,32.2 L112.72,33.72 L135.08,33.72 Z"
              fill="url(#linearGradient-3)"
            />
            <path
              id="形状"
              d="M157.68,20 L187.68,20 L187.68,18.88 L157.2,18.88 L157.2,14.84 L193.48,14.84 L193.48,26.16 C193.48,26.56 193.373333,26.9 193.16,27.18 C192.946667,27.46 192.673333,27.7 192.34,27.9 C192.006667,28.1 191.646667,28.2466667 191.26,28.34 C190.873333,28.4333333 190.52,28.48 190.2,28.48 L157.2,28.48 L157.2,24.4 L187.68,24.4 L187.68,23.32 L157.68,23.32 L157.68,20 Z M162.52,14.32 L162.52,13.6 L156.56,13.6 L156.56,9.8 L162.52,9.8 L162.52,8.76 L157.16,8.76 L157.16,5.48 L162.52,5.48 L162.52,4.44 L156.56,4.44 L156.56,0.64 L162.52,0.64 L162.52,0 L168.72,0 L168.72,0.64 L174.68,0.64 L174.68,4.44 L168.72,4.44 L168.72,5.48 L174.12,5.48 L174.12,8.76 L168.72,8.76 L168.72,9.8 L174.68,9.8 L174.68,13.6 L168.72,13.6 L168.72,14.32 L162.52,14.32 Z M181.68,14.32 L181.68,13.6 L175.76,13.6 L175.76,9.8 L181.68,9.8 L181.68,8.76 L176.32,8.76 L176.32,5.48 L181.68,5.48 L181.68,4.44 L175.76,4.44 L175.76,0.64 L181.68,0.64 L181.68,0 L187.88,0 L187.88,0.64 L193.88,0.64 L193.88,4.44 L187.88,4.44 L187.88,5.48 L193.28,5.48 L193.28,8.76 L187.88,8.76 L187.88,9.8 L193.88,9.8 L193.88,13.6 L187.88,13.6 L187.88,14.32 L181.68,14.32 Z M186.76,38.6 L169.52,38.6 C169.226667,38.6 168.906667,38.56 168.56,38.48 C168.213333,38.4 167.886667,38.28 167.58,38.12 C167.273333,37.96 167.013333,37.7533333 166.8,37.5 C166.586667,37.2466667 166.48,36.9466667 166.48,36.6 L166.48,29.36 L172.64,29.36 L172.64,34.56 L186.76,34.56 L186.76,38.6 Z M164.56,29.36 L162.24,38.52 L156.08,38.52 L158.4,29.36 L164.56,29.36 Z M192.36,29.36 L194.56,38.52 L188.4,38.52 L186.2,29.36 L192.36,29.36 Z M181.88,29.36 L183,33.72 L176.04,33.72 L174.92,29.36 L181.88,29.36 Z"
              fill="url(#linearGradient-4)"
            />
            <path
              id="形状"
              d="M226.92,38.56 L226.92,4 C226.92,3.57333333 227.033333,3.18 227.26,2.82 C227.486667,2.46 227.766667,2.16 228.1,1.92 C228.433333,1.68 228.806667,1.49333333 229.22,1.36 C229.633333,1.22666667 230.04,1.16 230.44,1.16 L244.92,1.16 L244.92,33.6 L246.68,33.6 L246.68,38.56 L242.2,38.56 C241.8,38.56 241.393333,38.4933333 240.98,38.36 C240.566667,38.2266667 240.193333,38.04 239.86,37.8 C239.526667,37.56 239.253333,37.26 239.04,36.9 C238.826667,36.54 238.72,36.1333333 238.72,35.68 L238.72,6.08 L233.12,6.08 L233.12,38.56 L226.92,38.56 Z M213.72,38.56 L213.72,10.64 L207.96,10.64 L207.96,5.68 L213.72,5.68 L213.72,0.08 L219.76,0.08 L219.76,5.68 L225.6,5.68 L225.6,10.64 L219.76,10.64 L219.76,38.56 L213.72,38.56 Z M221.36,38.56 L220.76,11.68 L224.92,11.68 L225.48,38.56 L221.36,38.56 Z M208.08,38.56 L208.6,11.68 L212.68,11.68 L212.16,38.56 L208.08,38.56 Z"
              fill="url(#linearGradient-5)"
            />
            <path
              id="形状"
              d="M298,26.4 L291.36,26.4 C290.826667,26.4 290.293333,26.2533333 289.76,25.96 L279.32,19.92 L269.2,25.96 C268.693333,26.2533333 268.16,26.4 267.6,26.4 L260.84,26.4 L260.44,21.72 L265.8,21.72 L270.24,19.16 L260.12,19.16 L260.12,14.52 L276.2,14.52 L276.2,11.84 L282.4,12.2 L282.4,14.52 L287.48,14.52 L286.76,12.84 L293,12.84 L293.72,14.52 L298.48,14.52 L298.48,19.16 L288.44,19.16 L293,21.72 L298.44,21.72 L298,26.4 Z M278.4,27.4 L278.4,35.84 C278.4,36.2666667 278.286667,36.64 278.06,36.96 C277.833333,37.28 277.54,37.5466667 277.18,37.76 C276.82,37.9733333 276.433333,38.1333333 276.02,38.24 C275.606667,38.3466667 275.226667,38.4 274.88,38.4 L260.6,38.4 L260.6,29.96 C260.6,29.5333333 260.713333,29.1533333 260.94,28.82 C261.166667,28.4866667 261.453333,28.22 261.8,28.02 C262.146667,27.82 262.526667,27.6666667 262.94,27.56 C263.353333,27.4533333 263.746667,27.4 264.12,27.4 L278.4,27.4 Z M297.96,27.4 L297.96,35.84 C297.96,36.2933333 297.846667,36.68 297.62,37 C297.393333,37.32 297.106667,37.58 296.76,37.78 C296.413333,37.98 296.033333,38.1333333 295.62,38.24 C295.206667,38.3466667 294.813333,38.4 294.44,38.4 L280.16,38.4 L280.16,29.96 C280.16,29.5333333 280.273333,29.16 280.5,28.84 C280.726667,28.52 281.02,28.2533333 281.38,28.04 C281.74,27.8266667 282.12,27.6666667 282.52,27.56 C282.92,27.4533333 283.306667,27.4 283.68,27.4 L297.96,27.4 Z M278.4,0.36 L278.4,8.76 C278.4,9.18666667 278.286667,9.56 278.06,9.88 C277.833333,10.2 277.546667,10.4666667 277.2,10.68 C276.853333,10.8933333 276.473333,11.0533333 276.06,11.16 C275.646667,11.2666667 275.253333,11.32 274.88,11.32 L260.6,11.32 L260.6,2.88 C260.6,2.45333333 260.713333,2.08 260.94,1.76 C261.166667,1.44 261.46,1.17333333 261.82,0.96 C262.18,0.746666667 262.56,0.593333333 262.96,0.5 C263.36,0.406666667 263.746667,0.36 264.12,0.36 L278.4,0.36 Z M297.96,0.36 L297.96,8.76 C297.96,9.21333333 297.846667,9.6 297.62,9.92 C297.393333,10.24 297.106667,10.5 296.76,10.7 C296.413333,10.9 296.033333,11.0533333 295.62,11.16 C295.206667,11.2666667 294.813333,11.32 294.44,11.32 L280.16,11.32 L280.16,2.88 C280.16,2.45333333 280.273333,2.08 280.5,1.76 C280.726667,1.44 281.02,1.18 281.38,0.98 C281.74,0.78 282.12,0.626666667 282.52,0.52 C282.92,0.413333333 283.306667,0.36 283.68,0.36 L297.96,0.36 Z M266.8,4.64 L266.8,7.04 L272.2,7.04 L272.2,4.64 L266.8,4.64 Z M286.4,4.64 L286.4,7.04 L291.72,7.04 L291.72,4.64 L286.4,4.64 Z M266.8,31.72 L266.8,34.08 L272.2,34.08 L272.2,31.72 L266.8,31.72 Z M286.4,31.72 L286.4,34.08 L291.72,34.08 L291.72,31.72 L286.4,31.72 Z"
              fill="url(#linearGradient-6)"
            />
            <polygon
              id="路径"
              fill="url(#linearGradient-7)"
              points="342.36 38.48 329.52 15.36 319.64 38.48 312.88 38.48 329.32 0.08 336.04 0.08 330.48 13.08 335.12 13.08 349.28 38.48"
            />
            <path
              id="形状"
              d="M380.24,38.68 L380.24,26.48 L364.04,26.48 L364.04,21.52 L380.24,21.52 L380.24,5.6 L365.48,5.6 L365.48,0.64 L401.08,0.64 L401.08,5.6 L386.44,5.6 L386.44,21.52 L402.56,21.52 L402.56,26.48 L386.44,26.48 L386.44,38.68 L380.24,38.68 Z M370.04,19.36 L366.72,7.72 L372.92,7.72 L376.2,19.36 L370.04,19.36 Z M390.36,19.36 L393.68,7.72 L399.84,7.72 L396.56,19.36 L390.36,19.36 Z"
              fill="url(#linearGradient-8)"
            />
            <path
              id="形状"
              d="M452,19.6 L452,35.68 C452,36.1333333 451.9,36.5266667 451.7,36.86 C451.5,37.1933333 451.24,37.48 450.92,37.72 C450.6,37.96 450.246667,38.14 449.86,38.26 C449.473333,38.38 449.08,38.44 448.68,38.44 L418.48,38.44 L418.48,22.36 C418.48,21.48 418.826667,20.8 419.52,20.32 C420.213333,19.84 420.96,19.6 421.76,19.6 L452,19.6 Z M430.76,1.96 L424.8,12.44 L446.12,12.44 L442.08,4.28 L447.88,2.6 L453.4,13.56 C453.586667,14.0666667 453.646667,14.5533333 453.58,15.02 C453.513333,15.4866667 453.353333,15.8933333 453.1,16.24 C452.846667,16.5866667 452.506667,16.8666667 452.08,17.08 C451.653333,17.2933333 451.186667,17.4 450.68,17.4 L420.04,17.4 C419.586667,17.4 419.14,17.2933333 418.7,17.08 C418.26,16.8666667 417.9,16.58 417.62,16.22 C417.34,15.86 417.166667,15.4466667 417.1,14.98 C417.033333,14.5133333 417.12,14.04 417.36,13.56 L425.08,0.04 L430.76,1.96 Z M424.64,24.56 L424.64,33.52 L445.8,33.52 L445.8,24.56 L424.64,24.56 Z"
              fill="url(#linearGradient-9)"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ScreenTitle',
  props: {
    innerText: {
      type: String,
      default: '智慧机器人平台'
    }
  }
};
</script>

<style>
.u-svg-text{
  display: inline-block;
}
</style>
